import {
  Box,
  Button,
  Typography,
  Hidden,
  Grid,
  IconButton,
  Tooltip,
  Stack,
  Switch,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import { useEffect, useMemo, useState, ChangeEvent } from 'react';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import {
  enableDisableUser,
  getAuthorisedSignatoryTableList,
  updateAuthorisedSignatory,
} from '../../redux-store/actions/userManagement';
import {
  AddAuthorisedSignatoryRequestBody,
  authorisedsignatoryType,
  authorisedsignatoryListingType,
} from '../../redux-store/types/api-types';
import { Link as RouterLink } from 'react-router-dom';
import { DataTable } from '../DataTable';
import { Location } from 'history';
import { ConfirmationDialog } from '../commonComponents';
import { AccessHeader } from './relationShipManagers';
import { RootStateType } from '../../redux-store/reducers';
import { CursorDirection, USER_ROLES } from '../../utils/constant';

export default function AuthorisedSignatory({
  location,
}: {
  location: Location<{ distributorId: string }>;
}): JSX.Element {
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);
  const [authorisedSignatoryData, setAuthorisedSignatoryData] = useState<authorisedsignatoryType[]>(
    []
  );
  const history = useHistory();

  const { distributorId } = location.state || {};
  const [openDialog, setDialog] = useState<{
    authorisedSignatoryRowData: AddAuthorisedSignatoryRequestBody;
  } | null>(null);

  const {
    page: storePage,
    sortDirection: storeSortDirection,
    rowsPerPage: storeRowsPerPage,
    nextCursor: storeNextCursor,
    prevCursor: storePrevCursor,
    cursorDirection: storeCursorDirection,
    hasNext: storeHasNext,
    hasPrev: storeHasPrev,
    currentCursor: storeCurrentCursor,
    paginationRole,
  } = useSelector((store: RootStateType) => store.paramsObj);

  const isPaginationRoleIsDistributor = paginationRole === USER_ROLES?.AUTHORISEDSIGNATORY;

  const [currentPage, setCurrentPage] = useState(
    isPaginationRoleIsDistributor ? storePage || 1 : 1
  );
  const [hasNext, setHasNext] = useState(
    isPaginationRoleIsDistributor ? storeHasNext || false : false
  );
  const [hasPrev, setHasPrev] = useState(
    isPaginationRoleIsDistributor ? storeHasPrev || false : false
  );
  const [rowsPerPage, setRowsPerPage] = useState(
    isPaginationRoleIsDistributor ? storeRowsPerPage || 10 : 10
  );
  const [currentCursor, setCurrentCursor] = useState<string | null>(
    isPaginationRoleIsDistributor ? storeCurrentCursor || null : null
  );
  const [nextCursor, setNextCursor] = useState<string | null>(
    isPaginationRoleIsDistributor ? storeNextCursor || null : null
  );
  const [prevCursor, setPrevCursor] = useState<string | null>(
    isPaginationRoleIsDistributor ? storePrevCursor || null : null
  );
  const [cursorDirection, setCursorDirection] = useState<CursorDirection | undefined>(undefined);

  const headers = [
    {
      header: `Name`,
      renderCell: (row: authorisedsignatoryType) => {
        return (
          <Typography
            variant="h5"
            sx={{
              color: '#61D1D6',
              textDecoration: 'none',
              fontWeight: 500,
              fontSize: '14px',
              ':hover': {
                color: 'primary.main',
              },
            }}
            component={RouterLink}
            to={{
              pathname: 'authorised-signatory-details',
              state: { authorisedSignatoryId: row.id },
            }}>
            {row?.firstName || 'N/A'}
          </Typography>
        );
      },
    },
    {
      header: 'Mobile Number',
      valueGetter: (row: authorisedsignatoryType) => row?.phone || 'N/A',
    },
    {
      header: 'Email Id',
      valueGetter: (row: authorisedsignatoryType) => row?.email || 'N/A',
    },
    {
      header: AccessHeader,
      renderCell: (row: AddAuthorisedSignatoryRequestBody): JSX.Element => {
        return (
          <>
            <Stack
              sx={{
                alignItems: { xs: 'baseline', sm: 'center' },
                '.MuiSwitch-root': {
                  paddingLeft: { xs: '0px', sm: '12px' },
                  width: { xs: '52px', sm: '58px' },
                },
                '.MuiSwitch-switchBase': { paddingLeft: { xs: '0px', sm: '9px' } },
              }}>
              <Switch
                sx={{ '.MuiSwitch-switchBase': { color: 'black' } }}
                checked={row.isActive}
                onChange={() => setDialog({ authorisedSignatoryRowData: row })}
              />
            </Stack>
          </>
        );
      },
    },
    // {
    //   header: '',
    //   renderCell: (row: authorisedsignatoryType): JSX.Element => {
    //     return (
    //       <>
    //         {row.isActive ? (
    //           <Tooltip title="Edit">
    //             <IconButton
    //               component={RouterLink}
    //               to={{
    //                 pathname: 'edit-authorised-signatory',
    //                 state: { authorisedSignatoryId: row.id },
    //               }}
    //               sx={{
    //                 ':hover': {
    //                   bgcolor: '#F4FCFC',
    //                 },
    //                 '&.Mui-disabled': {
    //                   cursor: 'pointer',
    //                   pointerEvents: 'all',
    //                 },
    //               }}>
    //               <EditIcon />
    //             </IconButton>
    //           </Tooltip>
    //         ) : (
    //           <Typography
    //             variant="h5"
    //             component={RouterLink}
    //             to={{
    //               pathname: 'edit-authorised-signatory',
    //               state: { authorisedSignatoryId: row.id },
    //             }}
    //             sx={{
    //               color: '#61D1D6',
    //               textDecoration: 'none',
    //               fontWeight: 500,
    //               fontSize: '14px',
    //               ':hover': {
    //                 color: 'primary.main',
    //               },
    //             }}>
    //             View Details
    //           </Typography>
    //         )}
    //       </>
    //     );
    //   },
    // },
  ];

  useEffect(() => {
    let isComponentActive = true;
    (async function () {
      try {
        setLoading(true);
        const params = {
          limit: rowsPerPage,
          order: 'DESC',
          ...(currentCursor
            ? {
                cursor: currentCursor,
                ...(cursorDirection && { direction: cursorDirection }),
              }
            : {
                cursor: null,
              }),
        };
        if (distributorId) {
          const res = (await dispatch(
            getAuthorisedSignatoryTableList(Number(distributorId), params)
          )) as unknown as authorisedsignatoryListingType;
          const { data, nextCursor: nextC, prevCursor: prevC, hasNext, hasPrev } = res || {};
          setNextCursor(nextC || '');
          setPrevCursor(prevC || '');
          setHasNext(hasNext || false);
          setHasPrev(hasPrev || false);
          setLoading(false);
          setAuthorisedSignatoryData(data);
        } else {
          history.replace('/user-management');
        }
        if (!isComponentActive) {
          return;
        }
        setLoading(false);
      } catch (e) {
        console.error((e as Error).message);
      } finally {
        if (isComponentActive) setLoading(false);
      }
    })();
    return () => {
      isComponentActive = false;
    };
  }, [distributorId, currentPage, rowsPerPage, currentCursor, cursorDirection]);

  const handlePageChange = (event: ChangeEvent<unknown>, value: number) => {
    setCurrentPage(value);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(1); // Reset to first page
  };

  const handleCursorPageChange = (event: React.MouseEvent<HTMLButtonElement>, newPage: number) => {
    // If user clicks next
    if (newPage > currentPage - 1 && nextCursor) {
      setCurrentCursor(nextCursor);
      setCursorDirection(CursorDirection.NEXT);
    }
    // If user clicks prev
    else if (newPage < currentPage - 1 && prevCursor) {
      setCurrentCursor(prevCursor);
      setCursorDirection(CursorDirection.PREV);
    }
    // Optionally update currentPage if you want to show the page number
  };

  return (
    <>
      <Box sx={{ bgcolor: 'common.white', px: 4 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            pt: { xs: 2, sm: 7 },
            pb: { xs: 2, sm: 4 },
          }}>
          <Typography component="h2" sx={{ fontSize: { xs: 15, sm: 23 }, fontWeight: 500 }}>
            List of Authorized Signatories
          </Typography>
          <Hidden only="xs">
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              sx={{
                color: 'white',
                fontWeight: 500,
                fontSize: 14,
                mr: 2.5,
                py: 0.5,
                px: 3,
              }}
              onClick={() =>
                history.push('add-authorised-signatory', {
                  distributorId: distributorId.toString(),
                })
              }>
              Add Authorized Signatory
            </Button>
          </Hidden>
          <Hidden smUp={true}>
            <Button
              variant="outlined"
              startIcon={<AddIcon />}
              sx={{
                color: 'primary.main',
                fontWeight: 500,
                fontSize: 13,
                //mr: 2.5,
                py: 0.5,
                // px: 3,
                // whiteSpace: 'nowrap',
              }}
              onClick={() =>
                history.push('add-authorised-signatory', {
                  distributorId: distributorId.toString(),
                })
              }>
              Add Authorized Signatory
            </Button>
          </Hidden>
        </Box>
        <Grid item xs={12} sm={12} lg={12}>
          {useMemo(
            () => (
              <DataTable
                tableData={authorisedSignatoryData}
                tableHeader={headers}
                isLoading={isLoading}
                currentPage={currentPage}
                noOfPages={1}
                paginationAction={handlePageChange}
                renderAdditionalRow={true}
                tableBodyCustomStyles={{
                  '.MuiTableCell-root': {
                    borderBottom: 'none',
                  },
                }}
                tableHeaderCustomStyles={{
                  '&:last-child th': { border: 0 },
                  '.MuiTableCell-head': {
                    fontFamily: 'Poppins, sans-serif',
                    fontSize: 14,
                    fontWeight: 500,
                    color: 'primary.main',
                  },
                }}
                rowCustomStyles={{
                  '&:last-child td, &:last-child th': { border: 0 },
                  '.MuiTableCell-body ': { color: '#686e72' },
                  background: 'transparent',
                }}
                handleCursorPageChange={handleCursorPageChange}
                hasNext={hasNext}
                hasPrev={hasPrev}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                rowsPerPage={rowsPerPage}
              />
            ),
            [headers, isLoading, authorisedSignatoryData]
          )}
        </Grid>
      </Box>
      <ConfirmationDialog
        message={`Are you sure you want to ${
          openDialog?.authorisedSignatoryRowData.isActive ? 'disable' : 'enable'
        } the access to this user ?`}
        open={openDialog !== null}
        setOpen={() => setDialog(null)}
        onSave={async () => {
          setDialog(null);
          try {
            if (openDialog) {
              await dispatch(
                enableDisableUser({
                  role: USER_ROLES.SUBDISTRIBUTOR,
                  roleId: openDialog?.authorisedSignatoryRowData?.id as number,
                  status: openDialog?.authorisedSignatoryRowData?.isActive ? 'disable' : 'enable',
                })
              );
              const updatedRowList = authorisedSignatoryData?.map((row) => {
                if (row.id === openDialog?.authorisedSignatoryRowData.id) {
                  return { ...row, isActive: !openDialog?.authorisedSignatoryRowData.isActive };
                }
                return row;
              });
              setAuthorisedSignatoryData(updatedRowList);
            }
          } catch (e) {
            console.error((e as Error).message);
          }
        }}
        onCancel={() => setDialog(null)}
      />
    </>
  );
}
